import React from 'react'
import TextField from '@mui/material/TextField'

const MFACodeInput = ({ value, onChange, disabled }) => (
  <TextField
    value={value}
    onChange={(e) => {
      const numericValue = e.target.value.replace(/[^0-9]/g, '')
      onChange(numericValue)
    }}
    disabled={disabled}
    inputProps={{
      maxLength: 6,
      inputMode: 'numeric',
      style: {
        textAlign: 'center',
        letterSpacing: '12px',
        fontSize: '1.8rem',
        fontWeight: 500,
      },
    }}
    variant="outlined"
    fullWidth
    autoFocus
    sx={{
      '& .MuiOutlinedInput-root': {
        borderRadius: 3,
        backgroundColor: '#f9fafb',
        color: 'primary.main',
      },
    }}
  />
)

export default MFACodeInput
